// extracted by mini-css-extract-plugin
export default {"main":"B-Overview_main__yLcz5","text":"B-Overview_text__0DsYe","title":"B-Overview_title__L1v1f","gradient":"B-Overview_gradient__Er3zN","para":"B-Overview_para__lFfKz"};